// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
  //DEV
  apiKey: "AIzaSyB6PxIoP1WWRGyEuec3aVGVBTHEdppVgY8",
  authDomain: "unicomms-demo.firebaseapp.com",
  projectId: "unicomms-demo",
  storageBucket: "unicomms-demo.firebasestorage.app",
  messagingSenderId: "1016167289592",
  appId: "1:1016167289592:web:e5568b7e4236d954b9e10d",
  measurementId: "G-YM6QYZ8XRV",


//TSumeb
//  apiKey: "AIzaSyAC2DVu5qe67As7XSvhlDGYQxjFjzTsHjg",
//   authDomain: "tsumeb-town-council.firebaseapp.com",
//   projectId: "tsumeb-town-council",
//   storageBucket: "tsumeb-town-council.firebasestorage.app",
//   messagingSenderId: "145508785982",
//   appId: "1:145508785982:web:b06683641e48e10409566f",
//   measurementId: "G-E35HFS1HGM"

  
  // apiKey: "AIzaSyC3__HH8YWT9_coAkySrQXi3E65qTkdGjw",
  // authDomain: "omuthiya-town-council-707b3.firebaseapp.com",
  // projectId: "omuthiya-town-council-707b3",
  // storageBucket: "omuthiya-town-council-707b3.firebasestorage.app",
  // messagingSenderId: "75470487540",
  // appId: "1:75470487540:web:c317f5188e2d89559e43a1",
  // measurementId: "G-KTLKQ6DRJ8"

  // apiKey: "AIzaSyATQ4mVa5n8Vhpi-cm_HK1uMMQ5vMLRWro",
  // authDomain: "ecbdevelopment-9eafc.firebaseapp.com",
  // projectId: "ecbdevelopment-9eafc",
  // storageBucket: "ecbdevelopment-9eafc.appspot.com",
  // messagingSenderId: "328176385844",
  // appId: "1:328176385844:web:61b1ef0392c28021a6ef61",
  // measurementId: "G-13K3YGY0NE",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const appAuthWorker = initializeApp(firebaseConfig);

export const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const authWorker = getAuth(appAuthWorker);
export const storage = getStorage(app);
export const functions = getFunctions(app);
